<template>
    <div class="w-full flex flex-col items-center">
      <div class="header w-full">
        <div class="flex justify-between items-center w-full mb-4">
          <h1 class="title-main-account">{{ $t('gologin.title') }}</h1>
          
  
        </div>
        <div class="mt-4 mb-6 border-t border-blue-200"></div>
      </div>
  
      <div class="w-full flex flex-col items-center">
        <div class="my-account-section mt-8 flex flex-col gap-6 p-6 bg-white rounded-lg shadow-lg w-full max-w-4xl">
          <div class="leading-relaxed text-settings">
            {{ $t('gologin.details') }}
          </div>
        <h2 class="title-settings mb-2">{{ $t('gologin.getting') }}</h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 blue-area">
            <div class="flex items-center justify-between md:col-span-2">
            <div class="flex flex-col gap-3">
              <span class="text-settings bold-text"><span class="gradient-number mr-2">1</span> {{ $t('gologin.title1') }}</span>
              <button class="button-continu px-8 py-3 rounded-full mt-3" @click="openDownloadLink">
                <i class="fa-solid fa-cloud-arrow-down"></i> {{ $t('gologin.button1') }}
              </button>
            </div>
          </div>
          <div class="Barre md:col-span-2"></div>
          <div class="md:col-span-2"><span class="text-settings mb-3"><span class="gradient-number mr-2">2</span> <span class="bold-text">{{ $t('gologin.title2') }}</span> {{ $t('gologin.title2_1') }}</span>          </div>
          <div class="flex items-center justify-between">
            <div class="flex flex-col gap-3">
              <span class="text-settings">{{ $t('settings.email') }}</span>
              <div class="flex items-center">
                <span class="link-settings">{{ accountInfo.email }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 25 25"
                  fill="none"
                  class="ml-6 cursor-pointer"
                  @click="copyEmailToClipboard"
                >
                  <path d="M15.5 4.51551C15.438 4.51551 9.5 4.5 9.5 4.5C8.44199 4.5 7.50001 5.47051 7.50001 6.50001L6.922 6.51351C5.8645 6.51351 5 7.4705 5 8.5V18.5C5 19.5295 5.942 20.5 7.00001 20.5H14.5C15.558 20.5 16.5 19.5295 16.5 18.5H17C18.058 18.5 19 17.5295 19 16.5V8.51201L15.5 4.51551ZM14.5 19.5H7.00001C6.47501 19.5 6.00002 19.0095 6.00002 18.5V8.5C6.00002 7.75601 6.61201 7.50001 7.50001 7.50001V16.5C7.50001 17.5295 8.44199 18.5 9.5 18.5C9.5 18.5 14.921 18.4945 15.5045 18.4945C15.5045 19.1015 15.1065 19.5 14.5 19.5ZM15.5 15.0055H11C10.724 15.0055 10.5 14.782 10.5 14.506C10.5 14.23 10.724 14.0065 11 14.0065H15.5C15.776 14.0065 16 14.23 16 14.506C16 14.782 15.776 15.0055 15.5 15.0055ZM15.5 12.508H11C10.724 12.508 10.5 12.2845 10.5 12.0085C10.5 11.7325 10.724 11.509 11 11.509H15.5C15.776 11.509 16 11.7325 16 12.0085C16 12.284 15.776 12.508 15.5 12.508ZM16.5 8.5C15.9675 8.5 15.5 8.01952 15.5 7.50001C15.5 7.50001 15.5 6.487 15.5 5.5155V5.5145L18 8.5H16.5Z" fill="url(#paint0_linear_1054_1878)"/>
                  <defs>
                    <linearGradient id="paint0_linear_1054_1878" x1="5" y1="12.5" x2="19" y2="12.5" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#1E93FD"/>
                      <stop offset="1" stop-color="#3154C8"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
                    
  
          <div class="flex items-center justify-between">
            <div class="flex flex-col gap-3">
              <span class="text-settings">{{ $t('settings.password') }}</span>
              <div class="flex items-center">
                <span class="link-settings" v-if="passwordVisible">
                  {{ password }}
                  <i class="fa-solid fa-eye-slash"
                    @click="fetchPassword"
                    style="margin-left: 25px; background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; cursor: pointer;">
                  </i>
                </span>
                <span class="link-settings" v-else>
                  ***************
                  <i class="fa-solid fa-eye"
                    @click="fetchPassword"
                    style="margin-left: 25px; background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; cursor: pointer;">
                  </i>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 25 25"
                  fill="none"
                  class="ml-2 cursor-pointer"
                  @click="copyPasswordToClipboard"
                >
                  <path d="M15.5 4.51551C15.438 4.51551 9.5 4.5 9.5 4.5C8.44199 4.5 7.50001 5.47051 7.50001 6.50001L6.922 6.51351C5.8645 6.51351 5 7.4705 5 8.5V18.5C5 19.5295 5.942 20.5 7.00001 20.5H14.5C15.558 20.5 16.5 19.5295 16.5 18.5H17C18.058 18.5 19 17.5295 19 16.5V8.51201L15.5 4.51551ZM14.5 19.5H7.00001C6.47501 19.5 6.00002 19.0095 6.00002 18.5V8.5C6.00002 7.75601 6.61201 7.50001 7.50001 7.50001V16.5C7.50001 17.5295 8.44199 18.5 9.5 18.5C9.5 18.5 14.921 18.4945 15.5045 18.4945C15.5045 19.1015 15.1065 19.5 14.5 19.5ZM15.5 15.0055H11C10.724 15.0055 10.5 14.782 10.5 14.506C10.5 14.23 10.724 14.0065 11 14.0065H15.5C15.776 14.0065 16 14.23 16 14.506C16 14.782 15.776 15.0055 15.5 15.0055ZM15.5 12.508H11C10.724 12.508 10.5 12.2845 10.5 12.0085C10.5 11.7325 10.724 11.509 11 11.509H15.5C15.776 11.509 16 11.7325 16 12.0085C16 12.284 15.776 12.508 15.5 12.508ZM16.5 8.5C15.9675 8.5 15.5 8.01952 15.5 7.50001C15.5 7.50001 15.5 6.487 15.5 5.5155V5.5145L18 8.5H16.5Z" fill="url(#paint0_linear_1054_1878)"/>
                  <defs>
                    <linearGradient id="paint0_linear_1054_1878" x1="5" y1="12.5" x2="19" y2="12.5" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#1E93FD"/>
                      <stop offset="1" stop-color="#3154C8"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div class="Barre md:col-span-2"></div>
          <div class="md:col-span-2"><span class="text-settings mb-3"><span class="gradient-number mr-2">3</span> <span class="bold-text">{{ $t('gologin.title3') }}</span> {{ $t('gologin.title3_1') }}</span></div>
        </div>
      </div>
      <div class="my-need-help-section mt-8 flex flex-col gap-6 p-8 bg-white rounded-lg shadow-lg w-full max-w-4xl">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="flex flex-col  gap-3">
                <h2 class="title-settings mb-2">{{ $t('gologin.help') }}</h2>
                <div class="text-settings">{{ $t('gologin.help2') }}</div>
            </div>
            <div class="flex items-center justify-end">
                <button class="visit-faq px-8 py-3 rounded-full" @click="openGuide">
                    {{ $t('gologin.button2') }}
                </button>
            </div>
        </div>
      </div>


      </div>
    </div>
  

      <div 
        v-if="showToast" 
        :class="[
          'fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 text-white font-semibold rounded-lg shadow-lg transition-opacity duration-300',
          toastType === 'success' ? 'bg-green-500' : 'bg-red-500'
        ]"
        style="z-index: 9999;"
      >
        <i 
          :class="toastType === 'success' ? 'fas fa-check-circle mr-2' : 'fas fa-exclamation-circle mr-2'"
        ></i>
        {{ toastMessage }}
      </div>
  </template>
  
    
  <script>
  import api from '../plugins/axios';
  
  export default {
    name: 'SettingsView',
    data() {
      return {
        accountInfo: {
          email: '',
          mot_de_passe: '',
          entreprise: '',
          langue: this.$i18n.locale === 'fr' ? 'fr-FR' : 'en-US' 
        },
        showModal: false,
        newName: "",
        apiKey: '',
        showApiKey: false,
        isMobile: false,
        toastMessage: '',
        showToast: false,
        toastType: 'success',
        passwordVisible : false,
        password: "***************"
      };
    },
    computed: {
      displayLanguage: {
        get() {
          return this.accountInfo.langue === 'fr-FR' ? 'Français' : 'English';
        },
        set(value) {
          this.accountInfo.langue = value === 'Français' ? 'fr-FR' : 'en-US';
          this.changeLanguage();
        }
      }
    },
    methods: {
    openGuide() {
        const lang = this.$i18n.locale; 
        const url = lang === "fr" 
            ? "https://video.mirrorprofiles.com/video/comment-se-connecter-a-son-compte-c79t" 
            : "https://www.youtube.com/watch?v=ybrmcfpi6S8";
        
        window.open(url, "_blank"); 
    },

      openDownloadLink() {
         window.open("https://gologin.com/download/", "_blank");
      },
      showToastMessage(message) {
          this.toastMessage = message;
          this.showToast = true;
  
          setTimeout(() => {
            this.showToast = false;
            this.toastMessage = '';
          }, 3000);
        },
      openEditModal() {
        this.newName = this.accountInfo.entreprise; 
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      },
      async fetchPassword() {
        if (!this.passwordVisible) {
            try {
            const response = await api.get("/api/gologinInfo");

            if (response.data && response.data.storedPassword) {
                this.password = response.data.storedPassword;
                this.passwordVisible = true;
            } else {
                console.error("Réponse invalide de l'API", response.data);
            }
            } catch (error) {
            console.error("Erreur lors de la récupération du mot de passe :", error);
            }
        } else {
            this.password = "***************";
            this.passwordVisible = false;
        }
     },
      async updateName() {
        try {
          await api.post("/api/update-name", {
            Nom: this.newName,
          });
  
          this.accountInfo.entreprise = this.newName; 
          this.closeModal(); 
          this.toastType = "success";
          this.showToastMessage(this.$t('settings.nameUpdateSuccess'));
  
        } catch (error) {
          this.toastType = "error";
          this.showToastMessage(this.$t('settings.nameUpdateError'));
  
        }
      },
  
      goToSetPassword() {
        this.$router.push({ name: 'SetPassword' });
      },
      updateIsMobile() {
        this.isMobile = window.innerWidth <= 768; 
      },
      async fetchAccountInfo() {
        try {
          const response = await api.get('/api/account');
          this.accountInfo = {
            ...response.data,
            langue: response.data.langue || (this.$i18n.locale === 'fr' ? 'fr-FR' : 'en-US')
          };
        } catch (error) {
          console.error('Error fetching account information:', error);
        }
      },
      async fetchApiKey() {
        try {
          const response = await api.get('/api/integrations/api-key');
          this.apiKey = response.data.api_key;
        } catch (error) {
          console.error('Error fetching API key:', error);
        }
      },
      toggleApiKey() {
        if (!this.showApiKey && !this.apiKey) {
          this.fetchApiKey();
        }
        this.showApiKey = !this.showApiKey; 
      },
      changeLanguage() {
        const newLang = this.accountInfo.langue === 'fr-FR' ? 'fr' : 'en';
        this.$i18n.locale = newLang;
        localStorage.setItem('lang', newLang);
        localStorage.setItem('langue', newLang);
  
        this.updateAccountLanguage();
      },
      async updateAccountLanguage() {
        try {
          await api.post('/api/account/language', { 
            email: this.accountInfo.email, 
            newLanguage: this.accountInfo.langue 
          });
          this.toastType = "success";
          this.showToastMessage(this.$t('settings.languageUpdateSuccess'));
          window.location.reload()
        } catch (error) {
          this.toastType = "error";
          this.showToastMessage(this.$t('settings.languageUpdateError'));      }
      },
      copyEmailToClipboard() {
        const email = this.accountInfo.email;
        navigator.clipboard.writeText(email)
          .then(() => {
            this.toastType = "success";
            this.showToastMessage(this.$t('settings.emailCopied'));
          })
          .catch((err) => {
            console.error("Erreur lors de la copie de l'email :", err);
            this.toastType = "error";
            this.showToastMessage(this.$t('settings.emailCopyError'));
          });
      },
      copyPasswordToClipboard() {
        if (this.passwordVisible) {
          navigator.clipboard.writeText(this.password)
            .then(() => {
              this.toastType = "success";
              this.showToastMessage(this.$t('settings.passwordCopied'));
            })
            .catch((err) => {
              this.toastType = "error";
              console.error("Erreur lors de la copie du mot de passe :", err);
              this.showToastMessage(this.$t('settings.passwordCopyError'));
            });
        } else {
          this.fetchPassword();
          this.passwordVisible = true;
          setTimeout(() => {
            this.copyPasswordToClipboard();
          }, 1000);
        }
      },

  
    },
    async mounted() {
      await this.fetchAccountInfo();
      this.updateIsMobile();
      window.addEventListener("resize", this.updateIsMobile);
    }
  };
  </script>
  
    
    <style scoped>
    .settings-container {
      margin: auto;
    }
    .my-account-section,
    .integrations-section {
      max-width: 80%;
      padding: 2rem;
      border-radius: 10px;
      background: #FFF;
      box-shadow: 0px 10px 40px 0px rgba(30, 147, 253, 0.20);
      
    }

    .my-need-help-section {
      max-width: 80%;
      padding: 2rem;
      border-radius: 10px;
      background: #F4F4F4;
      box-shadow: 0px 10px 40px 0px rgba(30, 147, 253, 0.20);
      
    }
  
  
    .title-settings{
      color: #2C2C2C;
      font-family: Montserrat;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%; 
    }
  
    .text-settings{
      color: #000;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  
    .link-settings{
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  
    .link-settings i{
      font-size: 1rem;
    }

    .blue-area{
        border-radius: 20px;
        background: rgba(30, 147, 253, 0.10);
        padding: 2rem
    }

    .gradient-number {
        background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
        font-size: 1.1rem;
    }


    .bold-text {
        font-weight: bold; 
    }


    .button-continu {
        background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
        color: #FFF;
        box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
        transition: background 0.3s ease, box-shadow 0.3s ease;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
    }
    
    .button-continu:hover {
        background: linear-gradient(90deg, #3154C8 0%, #3154C8 100%);
        box-shadow: 0 6px 14px rgba(30, 147, 253, 0.4);
    }
    
    .button-continu:disabled {
        background: linear-gradient(90deg, #B0B0B0 0%, #8C8C8C 100%);
        box-shadow: none;
        cursor: not-allowed;
        color: #E0E0E0;
    }

    .Barre {
        width: 100%;        
        height: 2px;       
        background: #B8DCFF;
        margin: 10px 0;      
    }



    .visit-faq {
        border: 2px solid #1E93FD;
        background: #FFF;
        color: #1E93FD;
        transition: all 0.3s ease;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
    }
    
    .visit-faq span {
        background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; 
    }
    
    .visit-faq:hover {
        background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
        color: #FFF;
        border-color: transparent;
        box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
    }
    
    .visit-faq:hover span {
    -webkit-text-fill-color:#FFF; 
    }



  
    </style>
    